<div
  class="row mbs-tiles"
  [class.-loading]="loading"
  [class.-selected-rows]="isNeedSelectCard"
  [style.max-height]="maxHeight"
  [style.min-height]="minHeight">
  <!-- TODO: Add status classnames to .mbs-tile. Possibility values: .-primary (default, everything's ok), .-dangerous, .-warning, .-secondary (offline computer) -->
  @if (loading) {
    <mbs-loader [type]="$any(loaderType)" />
  }

  @for (item of data || []; track myTrackBy?.(item) ?? item) {
    <div class="col-3 col-xxl-2 mb-4">
      <mbs-tile
        [data]="item"
        [headers]="gridHeaders"
        [headerTemplate]="$any(headerTemplate)"
        [selectable]="isNeedSelectCard"
        [selected]="!!checkCardInSelected(item)"
        [selectedClass]="selectCardClass"
        [statusClass]="
          $any([
            item.statusClass || '',
            (multipleSelect && checkCardInSelected(item) && selectCardClass) || (selectedCardIndex === $index && selectCardClass) || ''
          ])
        "
        [templates]="$any(templates)"
        [tileTemplate]="tileTemplate"
        (click)="cardClickHandler($event, $index)" />
    </div>
  }

  @if (!loading && (!data || data.length === 0)) {
    <ng-container [ngTemplateOutlet]="$any(noDataIsTemplate() ? noDataMessage : noDataDefault)" />
  }
</div>

<ng-template #noDataDefault>
  <div class="col">
    <div
      class="mbs-table-grid_cell flex-grow-1 text-center text-sm border"
      role="cell">
      {{ noDataMessage || noDataMessageDefault }}
    </div>
  </div>
</ng-template>
